/**
 * Environment-aware logging utility
 * Only logs in development mode, silent in production
 * Enhanced with performance tracking and structured logging
 */

const isDevelopment = import.meta.env.DEV;

// Performance timing tracker
const timers = new Map<string, number>();

export const logger = {
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log('[INFO]', ...args);
    }
  },

  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn('[WARN]', ...args);
    }
  },

  error: (...args: any[]) => {
    // Always log errors, even in production
    console.error('[ERROR]', ...args);
  },

  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.log('[DEBUG]', ...args);
    }
  },

  // Performance timing
  time: (label: string) => {
    if (isDevelopment) {
      timers.set(label, performance.now());
    }
  },

  timeEnd: (label: string) => {
    if (isDevelopment) {
      const start = timers.get(label);
      if (start) {
        const duration = performance.now() - start;
        console.log(`⏱️ [PERF] ${label}: ${duration.toFixed(2)}ms`);
        timers.delete(label);
      }
    }
  },

  // For edge functions/server-side logging
  edgeLog: (message: string, data?: any) => {
    if (isDevelopment) {
      console.log(`[EDGE] ${message}`, data || '');
    }
  },

  edgeError: (message: string, error: any) => {
    // Always log errors
    console.error(`[EDGE ERROR] ${message}`, error);
  }
};
